import { render, staticRenderFns } from "./AlertDestinationList.vue?vue&type=template&id=5357cd36&scoped=true&lang=pug"
import script from "./AlertDestinationList.vue?vue&type=script&lang=ts"
export * from "./AlertDestinationList.vue?vue&type=script&lang=ts"
import style0 from "./AlertDestinationList.vue?vue&type=style&index=0&id=5357cd36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5357cd36",
  null
  
)

export default component.exports